import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Box, Modal, TextField } from '@mui/material';
import { fetchWithToken } from "../api/apiutils";

const EditModal = ({ open, handleClose, handleSave, item }) => {
  const [nameRu, setNameRu] = useState('');
  const [nameKk, setNameKk] = useState('');
  const [url, setUrl] = useState('');

  useEffect(() => {
    if (item) {
      setNameRu(item.name.ru || '');
      setNameKk(item.name.kk || '');
      setUrl(item.url || '');
    }
  }, [item]);

  const handleSaveClick = () => {
    handleSave({
      id: item.id,
      name: {
        ru: nameRu,
        kk: nameKk,
        en: item.name.en || '' 
      },
      url
    });
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          borderRadius: 1,
          boxShadow: 24,
          p: 4,
        }}
      >
        <TextField
          label="Наименование на русском"
          variant="outlined"
          fullWidth
          margin="normal"
          value={nameRu}
          onChange={(e) => setNameRu(e.target.value)}
        />
        <TextField
          label="URL"
          variant="outlined"
          fullWidth
          margin="normal"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
        />
        <Box mt={2}>
          <Button variant="contained" color="primary" onClick={handleSaveClick}>
            Изменить
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

const BanListTable = () => {
  const [banList, setBanList] = useState([]);
  const [editItem, setEditItem] = useState(null);  
  const [openEditModal, setOpenEditModal] = useState(false); 

  useEffect(() => {
    fetchWithToken('/api/banList')
      .then((response) => response.json())
      .then((data) => setBanList(data))
      .catch((error) => console.error('Ошибка при получении данных:', error));
  }, []);

  const handleDelete = (id) => {
    if (window.confirm('Вы уверены, что хотите удалить этот элемент?')) {
      fetchWithToken(`/api/banList/${id}`, { method: 'DELETE' })
        .then(response => {
          if (response.ok) {
            setBanList(prevList => prevList.filter(item => item.id !== id));
          } else {
            console.error('Ошибка при удалении:', response.statusText);
          }
        })
        .catch(error => console.error('Ошибка при удалении:', error));
    }
  };

  const handleEditClick = (item) => {
    setEditItem(item);
    setOpenEditModal(true);
  };

  const handleEditSave = (updatedItem) => {
    fetchWithToken('/api/banList', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updatedItem),
    })
      .then(response => response.json())
      .then(data => {
        setBanList(banList.map(item => (item.id === updatedItem.id ? data : item)));
        setEditItem(null);
        setOpenEditModal(false);
      })
      .catch(error => console.error('Ошибка при обновлении:', error));
  };

  return (
    <Box>
      <TableContainer component={Paper}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Имя</TableCell>
              <TableCell>URL</TableCell>
              <TableCell>Редактировать</TableCell>
              <TableCell>Удалить</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {banList.map((item, index) => (
              <TableRow key={item.id}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{item.name}</TableCell>
                <TableCell>{item.url}</TableCell>
                <TableCell>
                  <Button
                    variant="outlined"
                    color="primary"
                    style={{ color: '#ffffff', backgroundColor: '#4298D7' }}
                    onClick={() => handleEditClick(item)}
                  >
                    Редактировать
                  </Button>
                </TableCell>
                <TableCell>
                  <Button
                    variant="outlined"
                    color="primary"
                    style={{ color: '#ffffff', backgroundColor: '#FF6666' }}
                    onClick={() => handleDelete(item.id)}
                  >
                    Удалить
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {editItem && (
        <EditModal
          open={openEditModal}
          handleClose={() => setOpenEditModal(false)}
          handleSave={handleEditSave}
          item={editItem}
        />
      )}
    </Box>
  );
};

export default BanListTable;
